module.exports = __webpack_public_path__ + "img/avatar-female.250ebf9a.jpg";